<template>
  <div v-if="scope" class="scope-show-section" :id="`scope-partial-${scope.id}`">
    <div class="sub-title">audience id: # {{scope.id}}</div>

    <table class="unstriped">
      <tbody>
        <tr>
          <td>priority</td>
          <td class="text-right scope-show-priority">{{scope.priority}}</td>
        </tr>

        <tr>
          <td>groups selected</td>
          <td class="text-right scope-show-groups-selected">
            <ul v-if="onlySelectedGroups && onlySelectedGroups.length">
              <li v-for="group in onlySelectedGroups">
                <strong>{{group.name.replace(/\_/, ' ')}}</strong>
                <p class="selected-segments">
                  <group-name-tags :selectedNames="group.display_names"></group-name-tags>
                </p>
              </li>
            </ul>
            <span v-else class="scope-show-all-groups">all groups</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="messages" class="row">
      <div class="large-10 columns small-centered">
        <message-show v-for="(message, index) in messages"
                      :key="message.id"
                      :attachmentsUrl="messageUrl(message.id, 'campaign_attachments')"
                      :message="message"
                      :messageCountIndex="allowMultiMessages ? index + 1 : null"
                      :messageId="message.id"
                      :statsUrl="messageUrl(message.id, 'stats')"></message-show>

        <template v-if="isBudzAutoCampaign">
          <message-show v-for="message in messageReferred"
                        :key="message.id"
                        :attachmentsUrl="messageUrl(message.id, 'campaign_attachments')"
                        :message="message"
                        :messageId="message.id"
                        :statsUrl="messageUrl(message.id, 'stats')"
                        isReferral></message-show>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import GroupNameTags from '../GroupWidget/GroupNameTags'
  import MessageShow from './MessageShow'
  import OnlySelectedGroupsMixin from '../../mixins/OnlySelectedGroupsMixin'

  export default {
    props: {
      allowMultiMessages: Boolean,
      autoCampaignId: [Number, String],
      isBudzAutoCampaign: Boolean,
      scope: Object,
    },

    name: 'ScopeShow',

    components: {
      GroupNameTags,
      MessageShow
    },

    mixins: [OnlySelectedGroupsMixin],

    methods: {
      messageUrl(id, endpoint) {
        return `/api/v3/auto_campaign_messages/${id}/${endpoint}?auto_campaign_id=${this.autoCampaignId}`
      }
    },

    created() {
      if (this.scope) { this.groupsWithSelected = this.scope.groups_with_selected }
    },

    computed: {
      messages: function() {
        let scopeMessages = this.scope ? [...this.scope.messages] : []
        return scopeMessages.filter(message => message.priority === null)
      },

      messageReferred: function() {
        let scopeMessages = this.scope ? [...this.scope.messages] : []
        return scopeMessages.filter(message => message.priority === -1)
      },
    },

    watch: {
      scope: function() {
        this.groupsWithSelected = this.scope.groups_with_selected
      }
    }
  }
</script>